import { useState } from 'react';
import { theme } from '../theme.js';
import { useInstall } from '../lib/install.js';
import { Icon } from './Icon.js';

const DISMISS_KEY = 'keetcheck.installHintDismissed';

function readDismissed(): boolean {
  try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
}

/**
 * "Install MusterTap" prompt. Renders nothing when already installed or the
 * browser can't install. `dismissible` (dashboard) remembers a dismissal on
 * this device; the Profile page shows it regardless.
 */
export function InstallCard({ dismissible = false }: { dismissible?: boolean }) {
  const { mode, install } = useInstall();
  const [dismissed, setDismissed] = useState(() => dismissible && readDismissed());

  if (mode === 'installed' || mode === 'unavailable' || dismissed) return null;

  function dismiss() {
    setDismissed(true);
    try { localStorage.setItem(DISMISS_KEY, '1'); } catch { /* private mode etc. — just hide for now */ }
  }

  return (
    <div style={{
      margin: '12px 16px', padding: '12px 14px', borderRadius: 12,
      background: theme.surface, border: `1px solid ${theme.border}`,
      display: 'flex', alignItems: 'center', gap: 12, fontFamily: theme.font,
    }}>
      <img src="/icons/icon-192.png" alt="" width={36} height={36} style={{ borderRadius: 8, flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: theme.text }}>Install MusterTap</div>
        <div style={{ fontSize: 12, color: theme.textMuted, lineHeight: 1.4 }}>
          {mode === 'ios'
            ? <>Tap <strong>Share</strong> <Icon name="send" size={11} /> then <strong>Add to Home Screen</strong>.</>
            : 'Open it from your home screen like a normal app.'}
        </div>
      </div>
      {mode === 'prompt' && (
        <button onClick={() => void install()} style={{
          padding: '8px 14px', borderRadius: 8, border: 'none', cursor: 'pointer',
          background: theme.accent, color: theme.accentInk, fontSize: 13, fontWeight: 600,
          fontFamily: theme.font, flexShrink: 0,
        }}>
          Install
        </button>
      )}
      {dismissible && (
        <button onClick={dismiss} aria-label="Dismiss" style={{
          background: 'none', border: 'none', cursor: 'pointer', color: theme.textMuted, padding: 4, flexShrink: 0,
        }}>
          <Icon name="x" size={15} />
        </button>
      )}
    </div>
  );
}
